<template>
  <main v-if="$parent.isAuth" class="main account-page">
    <div class="main-wrapper">
      <section class="account-page__header">
        <div class="account-page__container">
          <h1 class="account-page__title">
            {{ $t('Личный кабинет') }}
          </h1>
        </div>
      </section>

      <section class="account-page__content">
        <div class="account-page__container">
          <div class="account-layout">
            <aside class="account-sidebar">
              <div class="account-sidebar__user">
                <div class="account-avatar">
                  {{ avatarLetter }}
                </div>

                <h2 class="account-sidebar__nickname">
                  {{ nickname || $t('Игрок') }}
                </h2>

                <p class="account-sidebar__email">
                  {{ email }}
                </p>
              </div>

              <div class="account-sidebar__divider"></div>

              <nav
                class="account-navigation"
                :aria-label="$t('Навигация профиля')"
              >
                <button
                  type="button"
                  :class="[
                    'account-navigation__item',
                    {
                      'account-navigation__item_active':
                        activeSection === 'profile',
                    },
                  ]"
                  @click="$router.replace({ path: '/profile' })"
                >
                  <svg
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M15 15.75V14.25C15 13.4544 14.6839 12.6913 14.1213 12.1287C13.5587 11.5661 12.7956 11.25 12 11.25H6C5.20435 11.25 4.44129 11.5661 3.87868 12.1287C3.31607 12.6913 3 13.4544 3 14.25V15.75"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                  </svg>

                  <span>{{ $t('Профиль') }}</span>
                </button>

                <button
                  type="button"
                  :class="[
                    'account-navigation__item',
                    {
                      'account-navigation__item_active':
                        activeSection === 'orders',
                    },
                  ]"
                  @click="
                    $router.replace({
                      path: '/profile',
                      query: { section: 'orders' },
                    })
                  "
                >
                  <svg
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M6.75 8.25L9 10.5L16.5 3"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.75 9V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H12"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span>{{ $t('История покупок') }}</span>
                </button>

                <button
                  type="button"
                  class="account-navigation__item account-navigation__item_logout"
                  @click="$parent.logout"
                >
                  <svg
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 12.75L15.75 9L12 5.25"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.75 9H6.75"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span>{{ $t('Выйти') }}</span>
                </button>
              </nav>
            </aside>

            <div class="account-main">
              <transition name="account-section" mode="out-in">
                <section
                  v-if="activeSection === 'profile'"
                  key="profile"
                  class="account-card"
                >
                  <header class="account-card__header">
                    <h2 class="account-card__title">
                      {{ $t('Редактирование профиля') }}
                    </h2>

                    <p class="account-card__description">
                      {{
                        $t(
                          'Обновите данные аккаунта. Изменения применяются сразу.',
                        )
                      }}
                    </p>
                  </header>

                  <form
                    class="profile-form"
                    @submit.prevent="updateProfileData"
                  >
                    <div class="profile-form__grid">
                      <label class="profile-field">
                        <span class="profile-field__label">
                          {{ $t('Никнейм') }}
                        </span>

                        <input
                          v-model="nickname"
                          type="text"
                          class="profile-field__input"
                          :placeholder="$t('Никнейм')"
                          autocomplete="nickname"
                          maxlength="50"
                          @input="filterInput($event, 'nickname', 'nickname')"
                        />
                      </label>

                      <label class="profile-field">
                        <span class="profile-field__label">
                          {{ $t('Email') }}
                        </span>

                        <input
                          v-model.trim="email"
                          type="email"
                          class="profile-field__input"
                          :placeholder="$t('Email')"
                          autocomplete="email"
                          maxlength="120"
                        />
                      </label>

                      <label class="profile-field">
                        <span class="profile-field__label">
                          {{ $t('Имя') }}
                        </span>

                        <input
                          v-model="name"
                          type="text"
                          class="profile-field__input"
                          :placeholder="$t('Имя')"
                          autocomplete="given-name"
                          maxlength="50"
                          @input="filterInput($event, 'name', 'name')"
                        />
                      </label>

                      <label class="profile-field">
                        <span class="profile-field__label">
                          {{ $t('Фамилия') }}
                        </span>

                        <input
                          v-model="surname"
                          type="text"
                          class="profile-field__input"
                          :placeholder="$t('Фамилия')"
                          autocomplete="family-name"
                          maxlength="50"
                          @input="filterInput($event, 'surname', 'name')"
                        />
                      </label>
                    </div>

                    <div class="profile-form__actions">
                      <button
                        type="submit"
                        class="button shadowed profile-form__save"
                        :disabled="!profileIsValid || profileUpdating"
                      >
                        <span v-if="!profileUpdating">
                          {{ $t('Сохранить изменения') }}
                        </span>

                        <span
                          v-else
                          class="profile-loader"
                          aria-hidden="true"
                        ></span>
                      </button>

                      <button
                        type="button"
                        class="button bordered profile-form__cancel"
                        :disabled="profileUpdating"
                        @click="resetProfile"
                      >
                        <span>{{ $t('Отмена') }}</span>
                      </button>
                    </div>

                    <transition name="profile-message">
                      <div
                        v-if="profileUpdateSuccessMessage"
                        class="profile-message profile-message_success"
                      >
                        {{ profileUpdateSuccessMessage }}
                      </div>
                    </transition>

                    <transition name="profile-message">
                      <div
                        v-if="profileUpdateErrorMessage"
                        class="profile-message profile-message_error"
                      >
                        {{ profileUpdateErrorMessage }}
                      </div>
                    </transition>
                  </form>

                  <div class="account-card__divider"></div>

                  <section class="password-section">
                    <header class="password-section__header">
                      <h3 class="password-section__title">
                        {{ $t('Смена пароля') }}
                      </h3>
                    </header>

                    <form
                      class="password-form"
                      @submit.prevent="updatePassword"
                    >
                      <div class="password-form__grid">
                        <label class="profile-field password-form__current">
                          <span class="profile-field__label">
                            {{ $t('Текущий пароль') }}
                          </span>

                          <div class="password-field">
                            <input
                              v-model="currentPassword"
                              :type="
                                visiblePasswords.current ? 'text' : 'password'
                              "
                              class="profile-field__input"
                              :placeholder="$t('Текущий пароль')"
                              autocomplete="current-password"
                            />

                            <button
                              type="button"
                              class="password-field__toggle"
                              :aria-label="
                                $t(
                                  visiblePasswords.current
                                    ? 'Скрыть пароль'
                                    : 'Показать пароль',
                                )
                              "
                              @click="togglePasswordVisibility('current')"
                            >
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  d="M2 12C4.4 7.8 7.7 5.7 12 5.7C16.3 5.7 19.6 7.8 22 12C19.6 16.2 16.3 18.3 12 18.3C7.7 18.3 4.4 16.2 2 12Z"
                                  stroke="currentColor"
                                  stroke-width="1.7"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="12"
                                  cy="12"
                                  r="3"
                                  stroke="currentColor"
                                  stroke-width="1.7"
                                />
                              </svg>
                            </button>
                          </div>
                        </label>

                        <label class="profile-field">
                          <span class="profile-field__label">
                            {{ $t('Новый пароль') }}
                          </span>

                          <div class="password-field">
                            <input
                              v-model="newPassword"
                              :type="visiblePasswords.new ? 'text' : 'password'"
                              class="profile-field__input"
                              :placeholder="$t('Новый пароль')"
                              autocomplete="new-password"
                            />

                            <button
                              type="button"
                              class="password-field__toggle"
                              :aria-label="
                                $t(
                                  visiblePasswords.new
                                    ? 'Скрыть пароль'
                                    : 'Показать пароль',
                                )
                              "
                              @click="togglePasswordVisibility('new')"
                            >
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  d="M2 12C4.4 7.8 7.7 5.7 12 5.7C16.3 5.7 19.6 7.8 22 12C19.6 16.2 16.3 18.3 12 18.3C7.7 18.3 4.4 16.2 2 12Z"
                                  stroke="currentColor"
                                  stroke-width="1.7"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="12"
                                  cy="12"
                                  r="3"
                                  stroke="currentColor"
                                  stroke-width="1.7"
                                />
                              </svg>
                            </button>
                          </div>
                        </label>

                        <label class="profile-field">
                          <span class="profile-field__label">
                            {{ $t('Повторите пароль') }}
                          </span>

                          <div class="password-field">
                            <input
                              v-model="repeatPassword"
                              :type="
                                visiblePasswords.repeat ? 'text' : 'password'
                              "
                              :class="[
                                'profile-field__input',
                                {
                                  'profile-field__input_error':
                                    passwordMismatch,
                                },
                              ]"
                              :placeholder="$t('Повторите пароль')"
                              autocomplete="new-password"
                            />

                            <button
                              type="button"
                              class="password-field__toggle"
                              :aria-label="
                                $t(
                                  visiblePasswords.repeat
                                    ? 'Скрыть пароль'
                                    : 'Показать пароль',
                                )
                              "
                              @click="togglePasswordVisibility('repeat')"
                            >
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  d="M2 12C4.4 7.8 7.7 5.7 12 5.7C16.3 5.7 19.6 7.8 22 12C19.6 16.2 16.3 18.3 12 18.3C7.7 18.3 4.4 16.2 2 12Z"
                                  stroke="currentColor"
                                  stroke-width="1.7"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="12"
                                  cy="12"
                                  r="3"
                                  stroke="currentColor"
                                  stroke-width="1.7"
                                />
                              </svg>
                            </button>
                          </div>

                          <span
                            v-if="passwordMismatch"
                            class="password-form__error"
                          >
                            {{ $t('Пароли не совпадают') }}
                          </span>
                        </label>
                      </div>

                      <transition name="password-requirements">
                        <div
                          v-if="newPassword.length > 0"
                          class="password-form__requirements"
                        >
                          <span
                            :class="{
                              'password-requirement_met':
                                newPassword.length >= 8,
                            }"
                          >
                            {{ $t('Не менее 8 символов') }}
                          </span>

                          <span
                            :class="{
                              'password-requirement_met': hasPasswordLetter,
                            }"
                          >
                            {{ $t('Минимум одна буква') }}
                          </span>

                          <span
                            :class="{
                              'password-requirement_met': hasPasswordNumber,
                            }"
                          >
                            {{ $t('Минимум одна цифра') }}
                          </span>
                        </div>
                      </transition>

                      <div class="password-form__actions">
                        <button
                          type="submit"
                          class="button shadowed password-form__submit"
                          :disabled="!passwordIsValid || passwordUpdating"
                        >
                          <span v-if="!passwordUpdating">
                            {{ $t('Изменить пароль') }}
                          </span>

                          <span
                            v-else
                            class="profile-loader"
                            aria-hidden="true"
                          ></span>
                        </button>

                        <button
                          type="button"
                          class="button bordered password-form__reset"
                          :disabled="passwordUpdating"
                          @click="resetPasswordForm"
                        >
                          <span>{{ $t('Очистить') }}</span>
                        </button>
                      </div>

                      <transition name="profile-message">
                        <div
                          v-if="passwordSuccessMessage"
                          class="profile-message profile-message_success"
                        >
                          {{ passwordSuccessMessage }}
                        </div>
                      </transition>

                      <transition name="profile-message">
                        <div
                          v-if="passwordErrorMessage"
                          class="profile-message profile-message_error"
                        >
                          {{ passwordErrorMessage }}
                        </div>
                      </transition>
                    </form>
                  </section>
                </section>

                <section v-else key="orders" class="account-card">
                  <header class="account-card__header">
                    <h2 class="account-card__title">
                      {{ $t('История покупок') }}
                    </h2>

                    <p class="account-card__description">
                      {{
                        $t(
                          'Здесь отображаются ваши последние заказы и их текущий статус.',
                        )
                      }}
                    </p>
                  </header>
                  <div v-if="orderHistory.length">
                    <div class="orders-table-wrapper">
                      <table class="orders-table">
                        <thead>
                          <tr>
                            <th>{{ $t('ID') }}</th>
                            <th>{{ $t('Дата') }}</th>
                            <th>{{ $t('Товар') }}</th>
                            <th>{{ $t('Сумма') }}</th>
                            <th>{{ $t('Статус') }}</th>
                            <th>{{ $t('Инвойс') }}</th>
                          </tr>
                        </thead>

                        <tbody>
                          <template v-for="group in groupedOrders">
                          <tr
                            :key="group.key"
                            class="orders-table__row orders-table__row_order"
                            :class="{
                              'orders-table__row_open': isGroupOpen(group),
                            }"
                          >
                            <td :data-label="$t('ID')">
                              <button
                                v-if="group.extraItems > 0"
                                type="button"
                                class="orders-toggle"
                                :aria-expanded="isGroupOpen(group) ? 'true' : 'false'"
                                :aria-label="
                                  isGroupOpen(group)
                                    ? $t('Свернуть заказ')
                                    : $t('Показать товары заказа')
                                "
                                @click="toggleGroup(group)"
                              >
                                <svg
                                  class="orders-toggle__chevron"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M4.5 2.5L8 6L4.5 9.5"
                                    stroke="currentColor"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>

                                <span class="orders-table__id">
                                  {{ group.id }}
                                </span>
                              </button>

                              <span v-else class="orders-table__id">
                                {{ group.id }}
                              </span>
                            </td>

                            <td :data-label="$t('Дата')">
                              <span class="orders-table__date">
                                {{ formatOrderDate(group.created_at) }}
                              </span>
                            </td>

                            <td :data-label="$t('Товар')">
                              <span class="orders-table__product">
                                {{ group.items[0].title }}
                              </span>

                              <span
                                v-if="group.extraItems > 0"
                                class="orders-table__extra"
                              >
                                +{{ group.extraItems }}
                              </span>
                            </td>

                            <td :data-label="$t('Сумма')">
                              <strong class="orders-table__price">
                                {{ group.sum }}
                                {{ group.currency_code }}
                              </strong>
                            </td>

                            <td :data-label="$t('Статус')">
                              <span
                                :class="[
                                  'order-status',
                                  getStatusClass(group.status),
                                ]"
                              >
                                {{ $t(group.status) }}
                              </span>
                            </td>

                            <td :data-label="$t('Инвойс')">
                              <button
                                v-if="canDownloadInvoice(group.invoiceSource)"
                                type="button"
                                class="invoice-download"
                                :disabled="
                                  isInvoiceDownloading(group.invoiceSource)
                                "
                                :aria-label="$t('Скачать инвойс PDF')"
                                @click="downloadInvoice(group.invoiceSource)"
                              >
                                <span
                                  v-if="
                                    isInvoiceDownloading(group.invoiceSource)
                                  "
                                  class="invoice-download__loader"
                                  aria-hidden="true"
                                ></span>

                                <template v-else>
                                  <svg
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                  >
                                    <path
                                      d="M9 2.25V11.25"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                    />

                                    <path
                                      d="M5.75 8L9 11.25L12.25 8"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />

                                    <path
                                      d="M3 13V14.25C3 15.0784 3.67157 15.75 4.5 15.75H13.5C14.3284 15.75 15 15.0784 15 14.25V13"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                    />
                                  </svg>

                                  <span>PDF</span>
                                </template>
                              </button>

                              <span v-else class="invoice-unavailable"></span>
                            </td>
                          </tr>

                          <tr
                            v-for="(item, itemIndex) in isGroupOpen(group)
                              ? group.items
                              : []"
                            :key="group.key + '-' + itemIndex"
                            class="orders-table__row orders-table__row_item"
                          >
                            <td :data-label="$t('ID')">
                              <span class="orders-table__branch" aria-hidden="true"></span>
                            </td>

                            <td :data-label="$t('Дата')"></td>

                            <td :data-label="$t('Товар')">
                              <span class="orders-table__product">
                                {{ item.title }}
                              </span>

                              <span
                                v-if="item.count > 1"
                                class="orders-table__count"
                              >
                                &times;{{ item.count }}
                              </span>
                            </td>

                            <td :data-label="$t('Сумма')">
                              <strong class="orders-table__price">
                                {{ item.sum }}
                                {{ item.currency_code }}
                              </strong>
                            </td>

                            <td :data-label="$t('Статус')">
                              <span
                                :class="[
                                  'order-status',
                                  getStatusClass(item.status),
                                ]"
                              >
                                {{ $t(item.status) }}
                              </span>
                            </td>

                            <td :data-label="$t('Инвойс')">
                              <span class="invoice-unavailable"></span>
                            </td>
                          </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                    <transition name="profile-message">
                      <div
                        v-if="invoiceErrorMessage"
                        class="profile-message profile-message_error invoice-error"
                        role="alert"
                        aria-live="assertive"
                      >
                        {{ invoiceErrorMessage }}
                      </div>
                    </transition>
                  </div>
                  <div v-else class="orders-empty">
                    <div class="orders-empty__icon">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M6 3H18V21L12 17L6 21V3Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9 8H15"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                        <path
                          d="M9 12H14"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>

                    <h3 class="orders-empty__title">
                      {{ $t('Покупок пока нет') }}
                    </h3>

                    <p class="orders-empty__text">
                      {{
                        $t(
                          'После оформления заказа он появится в этом разделе.',
                        )
                      }}
                    </p>

                    <button
                      type="button"
                      class="button shadowed orders-empty__button"
                      @click="goToStore"
                    >
                      <span>
                        {{ $t('ПЕРЕЙТИ В МАГАЗИН') }}
                      </span>
                    </button>
                  </div>
                </section>
              </transition>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Profile',

  props: {
    orderHistory: {
      type: Array,
      default: () => [],
    },

    orderHistoryLoading: {
      type: Boolean,
      default: false,
    },

    orderHistoryError: {
      type: String,
      default: '',
    },
  },

  emits: ['load-order-history'],

  data() {
    return {
      activeSection: 'profile',

      email: '',
      name: '',
      surname: '',
      nickname: '',

      invoiceDownloadingId: null,
      invoiceErrorMessage: '',
      invoiceErrorTimeout: null,

      expandedOrders: [],

      initialProfile: {
        email: '',
        name: '',
        surname: '',
        nickname: '',
      },

      profileUpdating: false,
      profileUpdateSuccessMessage: '',
      profileUpdateErrorMessage: '',

      currentPassword: '',
      newPassword: '',
      repeatPassword: '',

      passwordUpdating: false,
      passwordSuccessMessage: '',
      passwordErrorMessage: '',

      visiblePasswords: {
        current: false,
        new: false,
        repeat: false,
      },

      profileMessageTimeout: null,
      passwordMessageTimeout: null,
    }
  },

  computed: {
    avatarLetter() {
      const value = this.nickname || this.name || this.email || '?'

      return value.trim().charAt(0).toUpperCase()
    },

    // Один заказ приходит с бэка отдельной строкой на каждый товар - собираем
    // их обратно по deposit_id, чтобы в истории была одна строка на заказ
    groupedOrders() {
      const groups = []
      const byKey = {}

      this.orderHistory.forEach((order, index) => {
        const key =
          order.deposit_id === null ||
          order.deposit_id === undefined ||
          order.deposit_id === ''
            ? `single-${index}`
            : `order-${order.deposit_id}`

        if (!byKey[key]) {
          byKey[key] = {
            key,
            id: order.id,
            created_at: order.created_at,
            currency_code: order.currency_code,
            // инвойс всегда на весь заказ, поэтому берём любую его строку
            invoiceSource: order,
            items: [],
            sum: 0,
          }

          groups.push(byKey[key])
        }

        const group = byKey[key]

        group.items.push(order)
        group.sum = Number((group.sum + Number(order.sum || 0)).toFixed(2))
      })

      groups.forEach((group) => {
        group.status = this.getGroupStatus(group.items)
        group.extraItems = group.items.length - 1
      })

      return groups
    },

    profileIsValid() {
      return Boolean(
        this.nickname.trim().length >= 2 &&
          this.name.trim().length >= 2 &&
          this.surname.trim().length >= 2 &&
          this.isValidEmail(this.email),
      )
    },

    passwordMismatch() {
      return Boolean(
        this.repeatPassword && this.newPassword !== this.repeatPassword,
      )
    },

    hasPasswordLetter() {
      return /[A-Za-zА-Яа-яЁё]/.test(this.newPassword)
    },

    hasPasswordNumber() {
      return /\d/.test(this.newPassword)
    },

    passwordIsValid() {
      return Boolean(
        this.currentPassword.length > 0 &&
          this.newPassword.length >= 8 &&
          this.hasPasswordLetter &&
          this.hasPasswordNumber &&
          this.newPassword === this.repeatPassword,
      )
    },
  },

  watch: {
    '$route.query.section': {
      immediate: true,

      handler() {
        this.syncSectionFromRoute()
      },
    },
  },

  mounted() {
    this.getProfile()
    this.syncSectionFromRoute()
  },

  beforeDestroy() {
    if (this.profileMessageTimeout) {
      clearTimeout(this.profileMessageTimeout)
    }

    if (this.passwordMessageTimeout) {
      clearTimeout(this.passwordMessageTimeout)
    }

    if (this.invoiceErrorTimeout) {
      clearTimeout(this.invoiceErrorTimeout)
    }
  },

  methods: {
    // Статус всего заказа: незавершённое важнее ошибки, ошибка важнее успеха
    getGroupStatus(items) {
      const statuses = items.map((item) =>
        String(item.status || '')
          .toLowerCase()
          .trim(),
      )

      const pending = items[statuses.indexOf('pending')]
      if (pending) {
        return pending.status
      }

      const failed = items[statuses.indexOf('error')]
      if (failed) {
        return failed.status
      }

      return items.length ? items[0].status : ''
    },

    isGroupOpen(group) {
      return this.expandedOrders.indexOf(group.key) !== -1
    },

    toggleGroup(group) {
      const position = this.expandedOrders.indexOf(group.key)

      if (position === -1) {
        this.expandedOrders.push(group.key)
      } else {
        this.expandedOrders.splice(position, 1)
      }
    },

    canDownloadInvoice(order) {
      if (!order || !order.deposit_id) {
        return false
      }

      if (typeof order.invoice_available === 'boolean') {
        return order.invoice_available
      }

      const status = String(order.status || '')
        .toLowerCase()
        .trim()

      return [
        'success',
        'successful',
        'paid',
        'completed',
        'accepted',
      ].includes(status)
    },

    isInvoiceDownloading(order) {
      return (
        Boolean(order && order.deposit_id) &&
        String(this.invoiceDownloadingId) === String(order.deposit_id)
      )
    },

    async downloadInvoice(order) {
      if (
        !this.canDownloadInvoice(order) ||
        this.invoiceDownloadingId !== null
      ) {
        return
      }

      this.invoiceDownloadingId = order.deposit_id
      this.clearInvoiceError()

      try {
        const response = await this.$http.get(
          `orders/${encodeURIComponent(order.deposit_id)}/invoice`,
          {
            responseType: 'blob',
            timeout: 30000,
          },
        )

        const contentType = String(
          response.headers?.['content-type'] || '',
        ).toLowerCase()

        /*
         * The endpoint may return a JSON error body as a Blob.
         */
        if (!contentType.includes('application/pdf')) {
          const message = await this.readBlobError(response.data)

          throw new Error(message || this.$t('Сервер не вернул PDF-файл'))
        }

        const blob = new Blob([response.data], {
          type: 'application/pdf',
        })

        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = blobUrl
        link.download = this.getInvoiceFilename(order, response.headers)
        link.style.display = 'none'

        document.body.appendChild(link)
        link.click()
        link.remove()

        window.setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl)
        }, 1000)
      } catch (error) {
        let message = ''

        if (error.response?.data instanceof Blob) {
          message = await this.readBlobError(error.response.data)
        }

        this.showInvoiceError(
          message ||
            error.response?.data?.message ||
            error.message ||
            this.$t('Не удалось скачать инвойс'),
        )
      } finally {
        this.invoiceDownloadingId = null
      }
    },

    async readBlobError(blob) {
      if (!(blob instanceof Blob)) {
        return ''
      }

      try {
        const text = await blob.text()

        if (!text) {
          return ''
        }

        const data = JSON.parse(text)

        return data.message || data.error || ''
      } catch (error) {
        return ''
      }
    },

    getInvoiceFilename(order, headers = {}) {
      const disposition = String(headers['content-disposition'] || '')

      const utfFilenameMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i)

      if (utfFilenameMatch?.[1]) {
        return decodeURIComponent(utfFilenameMatch[1])
      }

      const filenameMatch = disposition.match(/filename="?([^"]+)"?/i)

      if (filenameMatch?.[1]) {
        return filenameMatch[1]
      }

      // Юзеру показываем только номер заказа, но не его порядковый id в базе
      const orderNumber = String(order.id || '').replace(/[^A-Za-z0-9_-]/g, '-')

      return orderNumber ? `invoice-${orderNumber}.pdf` : 'invoice.pdf'
    },

    clearInvoiceError() {
      this.invoiceErrorMessage = ''

      if (this.invoiceErrorTimeout) {
        clearTimeout(this.invoiceErrorTimeout)
        this.invoiceErrorTimeout = null
      }
    },

    showInvoiceError(message) {
      this.clearInvoiceError()
      this.invoiceErrorMessage = String(message)

      this.invoiceErrorTimeout = setTimeout(() => {
        this.invoiceErrorMessage = ''
        this.invoiceErrorTimeout = null
      }, 5000)
    },
    async getProfile() {
      try {
        const response = await this.$http.get('user/profile')

        const profile = response.data?.payload || response.data || {}

        this.email = profile.email || ''
        this.name = profile.name || ''
        this.surname = profile.surname || ''
        this.nickname = profile.nickname || ''

        this.saveInitialProfile()
      } catch (error) {
        if (error.response?.status === 401) {
          this.openSignIn()
        }
      }
    },

    syncSectionFromRoute() {
      const section = this.$route.query.section

      if (section === 'orders') {
        this.activeSection = 'orders'

        if (!this.orderHistoryLoading && !this.orderHistory.length) {
          this.loadOrderHistory()
        }

        return
      }

      this.activeSection = 'profile'
    },

    openProfileSection() {
      if (this.orderHistoryLoading) {
        return
      }

      if (this.$route.path === '/profile' && !this.$route.query.section) {
        this.activeSection = 'profile'
        return
      }

      this.$router.replace({
        path: '/profile',
      })
    },

    openOrderHistory() {
      if (this.orderHistoryLoading) {
        return
      }

      this.activeSection = 'orders'

      const isAlreadyOnOrders =
        this.$route.path === '/profile' &&
        this.$route.query.section === 'orders'

      if (!isAlreadyOnOrders) {
        this.$router.replace({
          path: '/profile',
          query: {
            section: 'orders',
          },
        })
      }

      this.loadOrderHistory()
    },

    loadOrderHistory() {
      if (this.orderHistoryLoading) {
        return
      }

      this.$emit('load-order-history')
    },

    retryOrderHistory() {
      this.loadOrderHistory()
    },

    saveInitialProfile() {
      this.initialProfile = {
        email: this.email,
        name: this.name,
        surname: this.surname,
        nickname: this.nickname,
      }
    },

    resetProfile() {
      if (this.profileUpdating) {
        return
      }

      this.email = this.initialProfile.email
      this.name = this.initialProfile.name
      this.surname = this.initialProfile.surname
      this.nickname = this.initialProfile.nickname

      this.clearProfileMessages()
    },

    filterInput(event, field, type = 'name') {
      let value = event.target.value

      if (type === 'nickname') {
        value = value.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 50)
      } else {
        value = value
          .replace(/[^a-zA-Zа-яА-ЯёЁ\s'-]/g, '')
          .replace(/\s+/g, ' ')
          .trimStart()
          .slice(0, 50)
      }

      this[field] = value
    },

    isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())
    },

    async updateProfileData() {
      if (!this.profileIsValid || this.profileUpdating) {
        return
      }

      this.profileUpdating = true
      this.clearProfileMessages()

      const profileData = {
        email: this.email.trim(),
        name: this.name.trim(),
        surname: this.surname.trim(),
        nickname: this.nickname.trim(),
      }

      try {
        const response = await this.$http.put('user/profile', profileData)

        if (response.data.status === 'OK') {
          this.saveInitialProfile()

          this.showProfileSuccess(
            response.data.message || this.$t('Профиль успешно обновлён'),
          )
        } else {
          this.showProfileError(
            response.data.message || this.$t('Не удалось обновить профиль'),
          )
        }
      } catch (error) {
        if (error.response?.status === 401) {
          this.openSignIn()
          return
        }

        this.showProfileError(
          error.response?.data?.message ||
            this.$t('Не удалось обновить профиль'),
        )
      } finally {
        this.profileUpdating = false
      }
    },

    async updatePassword() {
      if (!this.passwordIsValid || this.passwordUpdating) {
        return
      }

      this.passwordUpdating = true
      this.clearPasswordMessages()

      const passwordData = {
        cur_password: this.currentPassword,
        new_password: this.newPassword,
        repeat_password: this.repeatPassword,
      }

      try {
        const response = await this.$http.post(
          'user/change-password',
          passwordData,
        )

        if (response.data.status === 'OK') {
          this.resetPasswordFields()

          this.showPasswordSuccess(
            response.data.message || this.$t('Пароль успешно изменён'),
          )
        } else {
          this.showPasswordError(
            response.data.message || this.$t('Не удалось изменить пароль'),
          )
        }
      } catch (error) {
        if (error.response?.status === 401) {
          this.openSignIn()
          return
        }

        this.showPasswordError(
          error.response?.data?.message ||
            this.$t('Не удалось изменить пароль'),
        )
      } finally {
        this.passwordUpdating = false
      }
    },

    togglePasswordVisibility(field) {
      if (!Object.prototype.hasOwnProperty.call(this.visiblePasswords, field)) {
        return
      }

      this.visiblePasswords[field] = !this.visiblePasswords[field]
    },

    resetPasswordFields() {
      this.currentPassword = ''
      this.newPassword = ''
      this.repeatPassword = ''

      this.visiblePasswords = {
        current: false,
        new: false,
        repeat: false,
      }
    },

    resetPasswordForm() {
      if (this.passwordUpdating) {
        return
      }

      this.resetPasswordFields()
      this.clearPasswordMessages()
    },

    clearProfileMessages() {
      this.profileUpdateSuccessMessage = ''
      this.profileUpdateErrorMessage = ''

      if (this.profileMessageTimeout) {
        clearTimeout(this.profileMessageTimeout)

        this.profileMessageTimeout = null
      }
    },

    clearPasswordMessages() {
      this.passwordSuccessMessage = ''
      this.passwordErrorMessage = ''

      if (this.passwordMessageTimeout) {
        clearTimeout(this.passwordMessageTimeout)

        this.passwordMessageTimeout = null
      }
    },

    showProfileSuccess(message) {
      this.clearProfileMessages()

      this.profileUpdateSuccessMessage = String(message)

      this.profileMessageTimeout = setTimeout(() => {
        this.profileUpdateSuccessMessage = ''

        this.profileMessageTimeout = null
      }, 3000)
    },

    showProfileError(message) {
      this.clearProfileMessages()

      this.profileUpdateErrorMessage = String(message)

      this.profileMessageTimeout = setTimeout(() => {
        this.profileUpdateErrorMessage = ''

        this.profileMessageTimeout = null
      }, 3000)
    },

    showPasswordSuccess(message) {
      this.clearPasswordMessages()

      this.passwordSuccessMessage = String(message)

      this.passwordMessageTimeout = setTimeout(() => {
        this.passwordSuccessMessage = ''

        this.passwordMessageTimeout = null
      }, 3000)
    },

    showPasswordError(message) {
      this.clearPasswordMessages()

      this.passwordErrorMessage = String(message)

      this.passwordMessageTimeout = setTimeout(() => {
        this.passwordErrorMessage = ''

        this.passwordMessageTimeout = null
      }, 3000)
    },

    formatOrderDate(date) {
      if (this.$parent && typeof this.$parent.formatDate === 'function') {
        return this.$parent.formatDate(date)
      }

      return date || '—'
    },

    getStatusClass(status) {
      const normalizedStatus = String(status || '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')

      if (
        ['accepted', 'completed', 'success', 'paid'].includes(normalizedStatus)
      ) {
        return 'order-status_success'
      }

      if (
        ['failed', 'cancelled', 'canceled', 'rejected'].includes(
          normalizedStatus,
        )
      ) {
        return 'order-status_error'
      }

      return 'order-status_processing'
    },

    goToStore() {
      this.$router.push({
        path: '/categories',
      })
    },

    openSignIn() {
      if (this.$parent && typeof this.$parent.openSignIn === 'function') {
        this.$parent.openSignIn()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.account-page {
  min-height: 50vh;

  background: radial-gradient(
      circle at 74% 0%,
      rgba(33, 193, 126, 0.035),
      transparent 34%
    ),
    var(--white-woodsmoke);
}

.account-page__container {
  width: 100%;
  max-width: 1212px;
  margin: 0 auto;
  padding: 0 16px;
}

.account-page__header {
  padding: 52px 16px 25px;
}

.account-page__header .account-page__container,
.account-page__content .account-page__container {
  padding: 0;
}

.account-page__title {
  margin: 0;

  font-family: var(--font-2);
  font-size: 34px;
  font-weight: 700;
  line-height: 44px;

  color: var(--gray-nurse);
}

.account-page__content {
  padding: 0 16px 110px;
}

.account-layout {
  display: grid;
  grid-template-columns: 292px minmax(0, 1fr);
  align-items: start;
  gap: 26px;
}

.account-sidebar,
.account-card {
  background: linear-gradient(
      145deg,
      rgba(33, 193, 126, 0.018),
      transparent 48%
    ),
    var(--bunker-86);

  border: 1px solid var(--outer-space);
  border-radius: 10px;

  box-shadow: inset 2px 2px 0 rgba(255, 255, 255, 0.018),
    inset -2px -2px 0 rgba(0, 0, 0, 0.18);
}

.account-sidebar {
  position: sticky;
  top: 24px;
  padding: 27px;
}

.account-sidebar__user {
  display: flex;
  align-items: center;
  flex-direction: column;

  text-align: center;
}

.account-avatar {
  width: 86px;
  height: 86px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: var(--font-3);
  font-size: 31px;
  font-weight: 700;
  line-height: 1;

  color: var(--racing-green);
  background: linear-gradient(145deg, var(--44), var(--31));

  border-radius: 19px;

  box-shadow: 0 9px 26px rgba(33, 193, 126, 0.22),
    inset 0 3px 0 rgba(255, 255, 255, 0.18), inset 0 -5px 0 rgba(0, 0, 0, 0.16);
}

.account-sidebar__nickname {
  max-width: 100%;
  margin: 17px 0 0;

  font-family: var(--font-2);
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  color: var(--gray-nurse);

  overflow-wrap: anywhere;
}

.account-sidebar__email {
  max-width: 100%;
  margin: 4px 0 0;

  font-family: var(--font-1);
  font-size: 12px;
  line-height: 18px;

  color: var(--mantle);

  overflow-wrap: anywhere;
}

.account-sidebar__divider {
  height: 1px;
  margin: 23px 0 20px;

  background: var(--outer-space);
}

.account-navigation {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.account-navigation__item {
  width: 100%;
  min-height: 45px;
  display: flex;
  align-items: center;
  gap: 13px;
  margin: 0;
  padding: 11px 15px;

  font-family: var(--font-1);
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  text-align: left;

  color: var(--pewter);
  background: transparent;

  border: 1px solid transparent;
  border-radius: 8px;

  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;

  svg {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
  }

  span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  @media (any-hover: hover) {
    &:hover {
      color: var(--gray-nurse);
      background: rgba(33, 193, 126, 0.04);
    }
  }

  &_active {
    color: var(--mountain-meadow);
    background: rgba(33, 193, 126, 0.115);
    border-color: rgba(33, 193, 126, 0.06);
  }

  &_logout {
    margin-top: 9px;
    color: #d98a8a;

    @media (any-hover: hover) {
      &:hover {
        color: #ff9b9b;
        background: rgba(255, 71, 102, 0.06);
      }
    }
  }
}

.account-main {
  min-width: 0;
  width: 100%;
}

.account-card {
  min-width: 0;
  padding: 32px;
}

.account-card__header {
  margin-bottom: 27px;
}

.account-card__title {
  margin: 0;

  font-family: var(--font-2);
  font-size: 22px;
  font-weight: 700;
  line-height: 29px;

  color: var(--gray-nurse);
}

.account-card__description {
  max-width: 700px;
  margin: 5px 0 0;

  font-family: var(--font-1);
  font-size: 12px;
  line-height: 19px;

  color: var(--mantle);
}

.account-card__divider {
  height: 1px;
  margin: 31px 0 26px;

  background: var(--outer-space);
}

.profile-form__grid,
.password-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.profile-field {
  display: block;
  min-width: 0;
  margin: 0;
}

.profile-field__label {
  display: block;
  margin-bottom: 7px;

  font-family: var(--font-1);
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;

  color: var(--pewter);
}

.profile-field__input {
  display: block;
  width: 100%;
  height: 46px;
  margin: 0;
  padding: 11px 14px;

  font-family: var(--font-1);
  font-size: 13px;
  line-height: 20px;

  color: var(--gray-nurse);
  background: rgba(7, 13, 10, 0.74);

  border: 1px solid var(--outer-space);
  border-radius: 8px;
  outline: none;

  box-shadow: inset 2px 2px 0 rgba(0, 0, 0, 0.32),
    inset -1px -1px 0 rgba(255, 255, 255, 0.02);

  transition: border-color 0.2s ease, background-color 0.2s ease,
    box-shadow 0.2s ease;

  &::placeholder {
    color: var(--mantle);
    opacity: 0.6;
  }

  &:focus {
    background: var(--heavy-metal);
    border-color: var(--31);

    box-shadow: inset 2px 2px 0 rgba(0, 0, 0, 0.3),
      0 0 0 3px rgba(33, 193, 126, 0.09);
  }

  &:-webkit-autofill {
    -webkit-text-fill-color: var(--gray-nurse);
    transition: background-color 9999s ease-in-out 0s;
  }

  &_error {
    border-color: rgba(255, 71, 102, 0.6);

    &:focus {
      border-color: #ff6f87;

      box-shadow: inset 2px 2px 0 rgba(0, 0, 0, 0.3),
        0 0 0 3px rgba(255, 71, 102, 0.08);
    }
  }
}

.profile-form__actions,
.password-form__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 26px;
}

.profile-form__save,
.password-form__submit {
  min-width: 225px;
  min-height: 47px;
  justify-content: center;
  margin: 0;
  padding: 12px 18px;

  font-family: var(--font-1);
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
  text-transform: none;
}

.profile-form__cancel,
.password-form__reset {
  min-width: 115px;
  min-height: 47px;
  justify-content: center;
  margin: 0;
  padding: 12px 18px;

  font-family: var(--font-1);
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.password-section__header {
  margin-bottom: 21px;
}

.password-section__title {
  margin: 0;

  font-family: var(--font-2);
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;

  color: var(--gray-nurse);
}

.password-section__description {
  margin: 5px 0 0;

  font-family: var(--font-1);
  font-size: 12px;
  line-height: 19px;

  color: var(--mantle);
}

.password-form__current {
  grid-column: 1 / -1;
}

.password-field {
  position: relative;
  min-width: 0;

  .profile-field__input {
    padding-right: 45px;
  }
}

.password-field__toggle {
  position: absolute;
  top: 50%;
  right: 12px;

  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  color: var(--mantle);
  background: transparent;

  border: 0;

  transform: translateY(-50%);
  transition: color 0.2s ease;

  svg {
    width: 17px;
    height: 17px;
  }

  @media (any-hover: hover) {
    &:hover {
      color: var(--mountain-meadow);
    }
  }
}

.password-form__error {
  display: block;
  margin-top: 6px;

  font-family: var(--font-1);
  font-size: 11px;
  line-height: 16px;

  color: #ff8b9e;
}

.password-form__requirements {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 15px;
  margin-top: 15px;

  span {
    position: relative;
    padding-left: 13px;

    font-family: var(--font-1);
    font-size: 10px;
    line-height: 15px;

    color: var(--mantle);

    transition: color 0.2s ease;

    &::before {
      content: '';

      position: absolute;
      top: 6px;
      left: 0;

      width: 4px;
      height: 4px;

      background: var(--mantle);
      border-radius: 50%;

      transition: background-color 0.2s ease;
    }
  }

  .password-requirement_met {
    color: var(--mountain-meadow);

    &::before {
      background: var(--mountain-meadow);
    }
  }
}

.profile-loader {
  width: 20px;
  height: 20px;
  display: block;

  border: 3px solid rgba(7, 15, 11, 0.3);
  border-top-color: var(--racing-green);
  border-radius: 50%;

  animation: profile-loader 0.75s linear infinite;
}

.profile-message {
  margin-top: 16px;
  padding: 11px 13px;

  font-family: var(--font-1);
  font-size: 12px;
  line-height: 18px;

  border-radius: 7px;
  overflow-wrap: anywhere;

  &_success {
    color: var(--mountain-meadow);
    background: var(--mountain-meadow-10);
    border: 1px solid var(--mountain-meadow-25);
  }

  &_error {
    color: #ff8b9e;
    background: rgba(255, 71, 102, 0.08);
    border: 1px solid rgba(255, 71, 102, 0.25);
  }
}

.orders-table-wrapper {
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  border: 1px solid var(--outer-space);
  border-radius: 8px;
}

.orders-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;

  th,
  td {
    padding: 15px 17px;
    text-align: left;
    vertical-align: middle;

    border-bottom: 1px solid var(--outer-space);
  }

  th {
    font-family: var(--font-1);
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    text-transform: uppercase;
    letter-spacing: 0.03em;

    color: var(--mantle);
    background: rgba(7, 13, 10, 0.5);
  }

  td {
    font-family: var(--font-1);
    font-size: 13px;
    line-height: 19px;

    color: var(--pewter);
    background: rgba(11, 18, 14, 0.34);

    overflow-wrap: anywhere;
  }

  th:nth-child(1),
  td:nth-child(1) {
    width: 15%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 17%;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 23%;
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 16%;
  }

  th:nth-child(5),
  td:nth-child(5) {
    width: 18%;
  }
  th:nth-child(6),
  td:nth-child(6) {
    width: 13%;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  @media (any-hover: hover) {
    tbody tr:hover td {
      background: rgba(33, 193, 126, 0.025);
    }
  }
}

.orders-table__id {
  font-family: var(--font-3);
  font-size: 10px;
  line-height: 15px;

  color: var(--mountain-meadow);

  overflow-wrap: anywhere;
}

.orders-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  margin: 0;
  padding: 0;

  text-align: left;

  color: var(--mountain-meadow);
  background: transparent;
  border: 0;

  cursor: pointer;

  @media (any-hover: hover) {
    &:hover .orders-table__id {
      color: var(--gray-nurse);
    }
  }
}

.orders-toggle__chevron {
  flex-shrink: 0;

  width: 12px;
  height: 12px;

  transition: transform 0.2s ease;
}

.orders-table__row_open .orders-toggle__chevron {
  transform: rotate(90deg);
}

.orders-table__extra {
  display: inline-block;

  margin-left: 6px;
  padding: 1px 6px;

  font-family: var(--font-1);
  font-size: 11px;
  line-height: 16px;

  color: var(--mountain-meadow);
  background: rgba(33, 193, 126, 0.12);
  border-radius: 20px;

  vertical-align: middle;
}

.orders-table__count {
  margin-left: 6px;

  font-size: 12px;

  color: var(--mantle);
}

.orders-table__branch {
  display: inline-block;

  width: 10px;
  height: 10px;

  border-left: 1px solid var(--outer-space);
  border-bottom: 1px solid var(--outer-space);
  border-bottom-left-radius: 3px;
}

.orders-table__row_item td {
  background: rgba(7, 13, 10, 0.45);
}

.orders-table__row_item .orders-table__product {
  color: var(--pewter);
}

.orders-table__date {
  display: block;
  overflow-wrap: anywhere;
}

.orders-table__product {
  display: block;

  color: var(--gray-nurse);

  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.orders-table__price {
  display: block;

  font-family: var(--font-2);
  font-size: 13px;
  font-weight: 600;
  line-height: 19px;

  color: var(--harvest-gold);

  white-space: normal;
  overflow-wrap: anywhere;
}

.order-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  min-height: 27px;
  padding: 5px 9px;

  font-family: var(--font-1);
  font-size: 10px;
  font-weight: 600;
  line-height: 15px;
  text-align: center;

  border-radius: 999px;

  white-space: normal;
  overflow-wrap: anywhere;

  &_success {
    color: var(--mountain-meadow);
    background: var(--mountain-meadow-10);
    border: 1px solid var(--mountain-meadow-25);
  }

  &_processing {
    color: var(--harvest-gold);
    background: rgba(213, 177, 91, 0.08);
    border: 1px solid rgba(213, 177, 91, 0.2);
  }

  &_error {
    color: #ff8b9e;
    background: rgba(255, 71, 102, 0.08);
    border: 1px solid rgba(255, 71, 102, 0.22);
  }
}

.orders-empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 54px 24px;

  text-align: center;

  background: rgba(7, 13, 10, 0.35);
  border: 1px solid var(--outer-space);
  border-radius: 8px;
}

.orders-empty__icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--mountain-meadow);
  background: var(--heavy-metal);

  border: 1px solid var(--outer-space);
  border-radius: 9px;

  svg {
    width: 25px;
    height: 25px;
  }
}

.orders-empty__title {
  margin: 18px 0 0;

  font-family: var(--font-2);
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  color: var(--gray-nurse);
}

.orders-empty__text {
  max-width: 390px;
  margin: 7px 0 0;

  font-family: var(--font-1);
  font-size: 12px;
  line-height: 19px;

  color: var(--mantle);
}

.orders-empty__button {
  min-width: 200px;
  justify-content: center;
  margin-top: 23px;

  font-family: var(--font-3);
  font-size: 10px;
  line-height: 14px;
}

.account-section-enter-active,
.account-section-leave-active,
.profile-message-enter-active,
.profile-message-leave-active,
.password-requirements-enter-active,
.password-requirements-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.account-section-enter,
.account-section-leave-to,
.profile-message-enter,
.profile-message-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

.password-requirements-enter,
.password-requirements-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

@keyframes profile-loader {
  to {
    transform: rotate(360deg);
  }
}

.invoice-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 30px;
  margin: 0;
  padding: 5px 7px;

  font-family: var(--font-1);
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;

  color: var(--mountain-meadow);
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;

  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease, opacity 0.2s ease;

  svg {
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }

  @media (any-hover: hover) {
    &:not(:disabled):hover {
      color: var(--gray-nurse);
      background: rgba(33, 193, 126, 0.09);
      border-color: rgba(33, 193, 126, 0.2);
    }
  }
}

.invoice-download__loader {
  width: 16px;
  height: 16px;
  display: block;

  border: 2px solid rgba(33, 193, 126, 0.22);
  border-top-color: var(--mountain-meadow);
  border-radius: 50%;

  animation: invoice-loader 0.7s linear infinite;
}

.invoice-unavailable {
  color: var(--mantle);
}

.invoice-error {
  margin-top: 14px;
}

@keyframes invoice-loader {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 991.98px) {
  .account-layout {
    grid-template-columns: 240px minmax(0, 1fr);
    gap: 18px;
  }

  .account-sidebar {
    padding: 21px;
  }

  .account-card {
    padding: 25px;
  }

  .orders-table {
    th,
    td {
      padding: 13px 11px;
      font-size: 12px;
    }
  }
  .account-page__header {
    padding: 30px 16px 18px;
  }

  .account-page__title {
    font-size: 26px;
    line-height: 34px;
  }

  .account-page__content {
    padding: 0 0 70px;
  }

  .account-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .account-sidebar {
    position: static;

    width: 100%;
    padding: 20px 16px;
  }

  .account-sidebar__user {
    display: grid;
    grid-template-columns: 64px minmax(0, 1fr);
    grid-template-rows: auto auto;
    column-gap: 15px;

    text-align: left;
  }

  .account-avatar {
    grid-row: 1 / 3;

    width: 64px;
    height: 64px;

    font-size: 23px;
    border-radius: 14px;
  }

  .account-sidebar__nickname {
    align-self: end;
    margin: 0;
  }

  .account-sidebar__email {
    align-self: start;
    margin-top: 2px;
  }

  .account-navigation {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .account-navigation__item_logout {
    grid-column: 1 / -1;
  }

  .account-main {
    width: 100%;
  }

  .account-card {
    width: 100%;
    padding: 22px 16px;
    border-radius: 8px;
  }

  .account-card__header {
    margin-bottom: 21px;
  }

  .profile-form__grid,
  .password-form__grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .password-form__current {
    grid-column: auto;
  }

  .profile-form__actions,
  .password-form__actions {
    align-items: stretch;
    flex-direction: column;
  }

  .profile-form__save,
  .profile-form__cancel,
  .password-form__submit,
  .password-form__reset {
    width: 100%;
    min-width: 0;
  }

  .orders-table-wrapper {
    overflow: visible;

    background: transparent;
    border: 0;
    border-radius: 0;
  }

  .orders-table,
  .orders-table tbody,
  .orders-table tr,
  .orders-table td {
    display: block;
    width: 100%;
  }

  .orders-table {
    table-layout: auto;
  }

  .orders-table thead {
    position: absolute;

    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;

    clip: rect(0, 0, 0, 0);
    white-space: nowrap;

    border: 0;
  }

  .orders-table tbody {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .orders-table__row {
    overflow: hidden;

    background: linear-gradient(
        145deg,
        rgba(33, 193, 126, 0.025),
        transparent 50%
      ),
      rgba(7, 13, 10, 0.42);

    border: 1px solid var(--outer-space);
    border-radius: 8px;

    box-shadow: inset 1px 1px 0 rgba(255, 255, 255, 0.018),
      inset -1px -1px 0 rgba(0, 0, 0, 0.16);
  }

  .orders-table td,
  .orders-table td:nth-child(n) {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(82px, 34%) minmax(0, 1fr);
    align-items: start;
    gap: 13px;
    padding: 12px 14px;

    text-align: right;

    background: transparent;
    border-bottom: 1px solid var(--outer-space);

    &::before {
      content: attr(data-label);

      min-width: 0;

      font-family: var(--font-1);
      font-size: 10px;
      font-weight: 600;
      line-height: 17px;
      text-align: left;
      text-transform: uppercase;
      letter-spacing: 0.03em;

      color: var(--mantle);

      overflow-wrap: anywhere;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  .orders-table tbody tr:last-child td {
    border-bottom: 1px solid var(--outer-space);

    &:last-child {
      border-bottom: 0;
    }
  }

  // В карточном виде строка товара - вложенная карточка, поэтому номер, дата
  // и инвойс в ней не нужны: они относятся к заказу целиком
  .orders-table__row_item {
    margin-left: 14px;

    background: rgba(7, 13, 10, 0.55);
  }

  .orders-table__row_item td:nth-child(1),
  .orders-table__row_item td:nth-child(2),
  .orders-table__row_item td:nth-child(6) {
    display: none;
  }

  .orders-toggle {
    width: 100%;

    justify-content: flex-end;
  }

  .orders-table__id,
  .orders-table__date,
  .orders-table__product,
  .orders-table__price {
    width: 100%;
    max-width: none;

    text-align: right;
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .order-status {
    justify-self: end;

    max-width: 100%;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .account-page__header {
    padding-top: 24px;
  }

  .account-card,
  .account-sidebar {
    padding: 18px 14px;
    border-radius: 8px;
  }

  .account-card__title {
    font-size: 19px;
    line-height: 25px;
  }

  .account-card__description {
    font-size: 11px;
    line-height: 18px;
  }

  .account-navigation {
    grid-template-columns: 1fr;
  }

  .account-navigation__item_logout {
    grid-column: auto;
  }

  .account-sidebar__divider {
    margin: 18px 0;
  }

  .password-form__requirements {
    flex-direction: column;
    gap: 6px;
  }

  .orders-table td,
  .orders-table td:nth-child(n) {
    grid-template-columns: minmax(72px, 31%) minmax(0, 1fr);
    gap: 10px;
    padding: 11px 12px;
  }

  .orders-empty {
    padding: 43px 17px;
  }

  .orders-empty__button {
    width: 100%;
    min-width: 0;
  }
  .invoice-download {
    justify-self: end;
  }
}

@media (max-width: 360px) {
  .account-sidebar__user {
    grid-template-columns: 54px minmax(0, 1fr);
    column-gap: 11px;
  }

  .account-avatar {
    width: 54px;
    height: 54px;
    font-size: 20px;
  }

  .orders-table td,
  .orders-table td:nth-child(n) {
    grid-template-columns: 1fr;
    gap: 4px;

    text-align: left;

    &::before {
      text-align: left;
    }
  }

  .orders-table__id,
  .orders-table__date,
  .orders-table__product,
  .orders-table__price {
    text-align: left;
  }

  .order-status {
    justify-self: start;
  }
  .invoice-download {
    justify-self: start;
  }
}
</style>
